<template>
    <div :class="'profiling'+(question.multiselectable ? ' multiselectable' : '')">
        <div v-if="page != 'info'" class="profilingOptions animate__animated animate__fadeIn">
            <button @click="openSettings();btnSfx();" class="btnSettings" type="button"></button>
            <button @click="$emit('eventClose');btnSfx();" class="btnClose" type="button"></button>
        </div>
        <div v-if="page == 'info'" class="profilingInfo">
            <h2 class="pt-2 pb-3">{{ $t("profiling.info_title") }}</h2>
            <img src="/images/bear/profiling.png" class="pl-4 pl-lg-5 pr-4 pr-lg-5 mb-2" />
            <p class="text-primary">{{ $t("profiling.info_subtitle") }}</p>
            <h2 class="mb-3"><b class="text-primary">{{ award.abbr(true) }} <img src="/images/token.png"/></b></h2>
            <b-button @click="start();btnSfx();" variant="primary" size="lg" class="mb-3 pt-3 pb-3">{{ $t("profiling.btn_info_start") }}</b-button>
            <button @click="$emit('eventClose');btnSfx();" type="button" class="btn btn-block btn-lg mb-3">{{ $t('base.btn_close') }}</button>
            <div>
                <b-form-checkbox id="checkbox-stopInfo" v-model="stopInfo" value="true" unchecked-value="false">
                  {{ $t('profiling.info_stop_checkbox') }}
                </b-form-checkbox>
            </div>
        </div>
        <div v-if="page == 'question'" class="profilingQuestion">
            <div class="bear-question animate__animated animate__zoomIn" >
                <img alt="Bear profiling question" :src="'/images/theme/'+(user.mtsCustomer ? 'mts': 'default')+'/bear/female-default.png'"/>
                <span>{{ $t("profiling.question_title") }}</span>
                <p>{{ question.text }}</p>
            </div>
            <p class="text-right text-primary animate__animated animate__fadeIn">{{ $t("profiling.question_subtitle") }}<b>{{ question.userProfit.abbr(true) }} <img src="/images/token.png" style="height: 1.5rem;" /></b></p>
            <p v-if="question.multiselectable" class="text-center text-yellow mb-2 animate__animated animate__fadeIn">{{ $t("profiling.question_multiselectable") }}</p>
            <ul class="answers animate__animated animate__fadeInUp">
                <li @click="onAnswerClick(a);btnSfx();" v-for="a in question.answers" :key="a.id" :class="selected.includes(a.id) ? 'selected' : ''">{{ a.text }} <i class="fas fa-check-circle"></i><i class="far fa-circle"></i></li>
            </ul>
            <div v-if="question.multiselectable" class="text-center animate__animated animate__fadeIn animate__delay-1s">
                <b-button @click="sendSegmentatioAnswers();btnSfx();" variant="yellow" size="lg">{{ $t('base.btn_next') }}</b-button>
            </div>
        </div>
        <div v-if="page == 'results'" class="profilingResults">
            <div class="bear-results mt-4 p-5 d-flex">
                <img alt="Bear profiling question" :src="'/images/theme/'+(user.mtsCustomer ? 'mts': 'default')+'/bear/female-default.png'" class="animate__animated animate__fadeInLeft"/>
                <p class="animate__animated animate__fadeInLeft animate__faster">{{ $t("profiling.question_results_title") }}</p>
            </div>
            <p class="text-center text-primary animate__animated animate__fadeIn">{{ $t("profiling.question_results_subtitle") }}</p>
            <h1 class="text-center text-primary animate__animated animate__fadeIn"><b>{{ totalUserProfit.abbr(true) }} <img src="/images/token.png" style="height: 3rem;"/></b></h1>
            
            <div class="text-center p-4 animate__animated animate__fadeIn">
                <b-button @click="$emit('eventNextVideo');btnSfx();" variant="primary" size="lg" class="mb-3 pt-3 pb-3" >{{ $t('base.btn_continue') }}</b-button>
                <button @click="$emit('eventClose');btnSfx();" type="button" class="btn btn-block btn-lg">{{ $t('base.btn_close') }}</button>
            </div>    
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import app from '../app'
import api from '../api'

const Profiling = Vue.component('profiling', {
    props: {
        options: {
            type: Object,
            default() {
                return { 
                    adSurveyQuestionAvailable: false,
                    userSegmentationQuestionAvailable: false,
                };
            }
        },
        adQuiz: {
            type: Object,
            default() {
                return { 
                    maxAttemptCount: 1,
                    questionCount: 1,
                    userProfit: 0,
                    videoUrl: undefined
                };
            }
        }
    },

    data() {
        return {
            totalUserProfit: 0,
            page: "info",
            award: 0,
            stopInfo: false,
            userSettings: null,
            checkedSegmentation: false,
            selected: [],
            question: {
                id: 0,
                text: "...",
                answers: [],
                userProfit: 0,
                multiselectable: false
            },
        }
    },

    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        
        init(){
            this.stopInfo = localStorage.profilingInfo == "false" ? false : true;
            this.page = this.stopInfo ? '' : 'info'; 

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            const $this = this;
            api.settings()
                .then(function (response) {
                    $this.userSettings = response.data;
                    if($this.page == "") $this.start();
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },

        start(){
            localStorage.setItem('profilingInfo', this.stopInfo);

            if(this.userSettings.userProfilingStatus != "ACCEPTED")
                this.openGdpr();
            else 
                this.next();
        },

        openGdpr(){
            const $this = this;
            this.$bvModal.msgBoxConfirm(this.htmlToVNode(this.$t('home.popup_profiling_gdpr_text')), {
                title: this.$t('home.popup_profiling_gdpr'),
                size: 'sm',
                buttonSize: 'md',
                okVariant: 'success',
                cancelVariant: 'primary',
                okTitle: this.$t('home.profiling_gdpr_btn_accept'),
                cancelTitle: this.$t('home.profiling_gdpr_btn_reject'),
                modalClass: 'profilingGDPRModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                api.setSettings({
                    segmentationOptOut: !value, 
                    surveyOptOut: !value, 
                    userProfilingStatus: value ? 'ACCEPTED' : 'REJECTED'
                })
                .then(function (response) {
                    $this.next();
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                    $this.$emit('eventClose');
                });
            })
            .catch(err => {
                $this.$emit('eventClose');
            })
            .then(r => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        next(){
            //console.log("NEXT");
            this.page = "question";
            this.selected = [];
            const $this = this;

            let loader = document.getElementById('loader');

            if (this.options.adSurveyQuestionAvailable){
                loader.classList.add("show");
                api.getAdSurveyQuestion(this.adQuiz.id)
                    .then(function (response) {
                        $this.question = response.data;
                    })
                    .catch(function (error) {
                        if(error.response.status != "404"){
                            api.baseErrorHendler(error);
                            $this.$emit('eventClose');
                        }
                        else {
                            $this.options.adSurveyQuestionAvailable = false; // prevent next call
                            $this.next();
                        }

                    })
                    .then(function () {
                        loader.classList.remove("show");
                    });
            }
            else if(this.options.userSegmentationQuestionAvailable && !this.checkedSegmentation){
                loader.classList.add("show");
                api.getUserSegmentationQuestion()
                    .then(function (response) {
                        $this.checkedSegmentation = true;
                        $this.question = response.data;
                    })
                    .catch(function (error) {
                        if(error.response.status != "404"){
                            api.baseErrorHendler(error);
                            $this.$emit('eventClose');
                        }
                        else {
                            $this.page = "results";
                        }

                    })
                    .then(function () {
                        loader.classList.remove("show");
                    });
            }
            else{
                $this.page = "results";
            }
        },

        onAnswerClick(answer){

            if(!this.options.adSurveyQuestionAvailable){

                if (this.question.multiselectable)
                {
                    let index = this.selected.indexOf(answer.id);
                    if(index != -1)
                        this.selected.splice(index, 1);
                    else 
                        this.selected.push(answer.id);
                }
                else{
                    this.selected.push(answer.id);
                    this.sendSegmentatioAnswers();
                }
                return;
            }

            this.selected.push(answer.id);

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            const $this = this;
            api.adSurveyAnswer(this.question.id, answer.id)
                .then(function (response) {
                    $this.totalUserProfit += $this.question.userProfit;
                    $this.$store.dispatch('auth/getMe');
                    $this.next();
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                    $this.selected = [];
                });
        },

        sendSegmentatioAnswers(){
            if(this.selected.length == 0) return;

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            const $this = this;
            api.userSegmentationAnswer(this.question.id, this.selected)
                .then(function (response) {
                    $this.totalUserProfit += $this.question.userProfit;
                    $this.next();
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                    $this.selected = [];
                });
        },      

        openSettings(){
            const $this = this;
            this.$bvModal.msgBoxConfirm($this.htmlToVNode($this.$t('profiling.popup_stop_text')), {
                size: 'sm',
                buttonSize: 'md',
                okVariant: 'danger',
                cancelVariant: 'primary',
                okTitle: $this.$t('profiling.popup_stop_btn'),
                cancelTitle: $this.$t('profiling.popup_stop_btn_cancel'),
                modalClass: 'profilingStopModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.setSettings({
                        segmentationOptOut: true, 
                        surveyOptOut: true, 
                        userProfilingStatus: 'REJECTED'
                    })
                    .then(function (response) {
                        $this.$root.$bvModal.msgBoxOk($this.htmlToVNode($this.$t('profiling.popup_stoped_text')), {
                            size: 'sm',
                            buttonSize: 'lg',
                            okTitle: $this.$t('base.btn_ok'),
                            modalClass: 'confirmModal',
                            hideHeaderClose: false,
                            centered: true
                        })
                        .then(r => {
                            $this.$store.dispatch('sound/sfx','Button');
                        });

                        $this.$emit('eventClose');
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                        $this.$emit('eventClose');
                    });
                }
            })
            .catch(err => {
                $this.$emit('eventClose');
            })
            .then(r => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        htmlToVNode(html) {
          return [
            this.$createElement('div', { domProps: { innerHTML: html } })
          ]
        }
        
    },

    mounted(){
        this.init();
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    }
});

export default Profiling
</script>